import request from '@/utils/request'

/**
 * 查询员工信息列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStaffInfos(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}